/*!--------------------------------------------------------
 * Copyright (C) Microsoft Corporation. All rights reserved.
 *--------------------------------------------------------*/
/*---------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 *--------------------------------------------------------*/
define("vs/code/browser/workbench/workbench.nls", {
	"vs/code/browser/workbench/workbench": [
		"$(remote) Visual Studio Code Playground: {0}/{1}",
		"Visual Studio Code Playground: {0}/{1}",
		"$(remote) Visual Studio Code Playground",
		"Visual Studio Code Playground",
		"Home"
	]
});